import React from 'react'
import { Switch } from 'antd'
import { styled } from 'styled-components'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

interface IWizrToggle {
  onChange?: any
  isEnabled?: boolean
  disabled?: boolean
  size?: 'default' | 'small'
}

const StyledSwitch = styled(Switch) <{ size?: 'small' | 'default' }>`
  ${({ size }) =>
    size === 'small' &&
    `
    width: 36px !important;
    height: 20px !important;
    padding: 0 !important;

    .ant-switch-handle {
      width: 16px;
      height: 16px;
      top: 4px;
      left: 2px;
    }

    .ant-switch-checked .ant-switch-handle {
      left: calc(100% - 18px); /* 36 - 16 - 2 */
    }

    .ant-switch-inner {
      display: none;
    }
  `}


  .ant-switch-checked {
    background-color: #1890ff;
  }

  .ant-switch-checked::after {
    background-color: white;
  }
`;


const WizrToggleButton = ({ isEnabled = false, onChange, disabled, size = 'default' }: IWizrToggle) => {
  return (
    <StyledSwitch
      checkedChildren={<CheckOutlined />}
      unCheckedChildren={<CloseOutlined />}
      onChange={onChange}
      checked={isEnabled}
      disabled={disabled}
      size={size}
    />
  )
}

export default WizrToggleButton
